import { css } from '@emotion/css'
import { borderRadius, spacing, fontSize, fontFamily, fontWeight, zIndex } from '../../styles'
import { shorthandHelper } from '../../styles/helpers'
import { colors } from '../../themes'

const styles = {
  tabsContainer: css({
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    fontFamily: fontFamily.body,

    '& > * + *': {
      marginLeft: -1,
    },
  }),

  tab: css({
    width: 70,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomColor: 'transparent',
    backgroundColor: colors.athensGray,
    padding: shorthandHelper([spacing.default, spacing.small]),
    fontFamily: fontFamily.body,
    fontSize: fontSize.small,
    color: colors.jumbo,
    cursor: 'pointer',

    '&[disabled]': {
      opacity: 0.5,
      pointerEvents: 'none',
    },
  }),

  activeTab: css({
    position: 'relative',
    zIndex: zIndex.level2,
    backgroundColor: colors.white,
    fontWeight: fontWeight.semiBold,
    color: colors.jumbo,

    '&::after': {
      content: '""',
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: colors.white,
      height: 3,
    },
  }),

  errorTab: css({
    color: colors.mandy,
    borderColor: colors.mandy,
    borderBottomColor: 'transparent',
  }),

  wrapper: css({
    boxSizing: 'border-box',
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    borderTopLeftRadius: 0,
    padding: spacing.default,
  }),

  wrapperError: css({
    borderColor: colors.mandy,
  }),

  toolbar: css({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',

    '& > * + *': {
      marginLeft: spacing.small,
    },
  }),

  toolbarItem: css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: borderRadius.default,
    cursor: 'pointer',
    padding: spacing.extraSmall,
    marginBottom: spacing.default,

    '&:hover': {
      backgroundColor: colors.catskillWhite,
    },
  }),

  toolbarSeparator: css({
    margin: shorthandHelper([0, spacing.small, spacing.default, spacing.default]),
    borderLeft: `1px solid ${colors.mystic}`,
    width: 1,
    height: fontSize.large,
  }),

  editor: css({
    display: 'block',
    outline: 'none',
    boxSizing: 'border-box',
    width: '100%',
    border: 0,
    padding: 0,
    resize: 'none',
    fontSize: fontSize.default,
    lineHeight: 1.2,
    fontFamily: fontFamily.body,
    overflowX: 'hidden',
    color: colors.jumbo,

    '&::placeholder': {
      color: colors.grayChateau,
    },
  }),

  preview: css({
    maxHeight: 438,
    overflowY: 'scroll',
  }),

  noPreview: css({
    fontFamily: fontFamily.body,
    fontSize: fontSize.small,
    fontStyle: 'italic',
    lineHeight: 1.2,
    color: colors.jumbo,
  }),
}

export default styles

export const previewSize = size =>
  css({
    height: size,
  })

export const editorSize = size => {
  switch (size) {
    case 'small':
      return css({
        minHeight: 100,
        maxHeight: 150,
      })

    case 'medium':
      return css({
        minHeight: 180,
        maxHeight: 320,
      })

    case 'large':
      return css({
        minHeight: 220,
        maxHeight: 400,
      })

    default:
      return css({
        minHeight: 140,
        maxHeight: 200,
      })
  }
}
